const destinations = [

    {
        id: 0,
		name: 'Mumbai',
		url: "https://cdn.pixabay.com/photo/2016/05/03/20/01/mumbai-1370023_960_720.jpg",
        price: 300,
        day: 5
    },
    {
        id: 1,
		name: 'Japan',
		url: "https://cdn.pixabay.com/photo/2014/10/07/13/48/mountain-477832_960_720.jpg",
        price: 700,
        day: 7
    },
    {
        id: 2,
		name: 'Thailand',
		url: "https://cdn.pixabay.com/photo/2016/11/08/05/54/agriculture-1807581_960_720.jpg",
        price: 400,
        day: 5
    },
    {
        id: 3,
		name: 'Australia',
		url: "https://cdn.pixabay.com/photo/2020/06/04/04/12/beach-5257079_960_720.jpg",
        price: 900,
        day: 6
    },
    {
        id: 4,
		name: 'Rome',
		url: "https://cdn.pixabay.com/photo/2017/01/01/17/39/rome-1945033_960_720.jpg",
        price: 750,
        day: 5
    },
    {
        id: 5,
		name: 'Newyork',
		url: "https://cdn.pixabay.com/photo/2016/11/22/19/17/buildings-1850129_960_720.jpg",
        price: 1000,
        day: 5
    },
    {
        id: 6,
		name: 'Spain',
		url: "https://cdn.pixabay.com/photo/2016/03/24/07/31/spain-1276209_960_720.jpg",
        price: 1000,
        day: 5
    },
    {
        id: 7,
		name: 'Egypt',
		url: "https://cdn.pixabay.com/photo/2017/01/14/20/55/cairo-1980350__340.jpg",
        price: 500,
        day: 5
    },
    {
        id: 8,
		name: 'China',
		url: "https://cdn.pixabay.com/photo/2018/09/13/19/54/great-wall-3675637_960_720.jpg",
        price: 500,
        day: 5
    },
    {
        id: 9,
		name: 'London',
		url: "https://cdn.pixabay.com/photo/2017/06/11/18/03/big-ben-2393098__340.jpg",
        price: 1000,
        day: 5
    },
    {
        id: 10,
		name: 'Paris',
		url: "https://cdn.pixabay.com/photo/2020/06/17/19/19/paris-5310783_960_720.jpg",
        price: 1000,
        day: 5
    },
    {
        id: 11,
		name: 'Russia',
		url: "https://cdn.pixabay.com/photo/2016/06/27/22/18/moscow-cathedral-mosque-1483524_960_720.jpg",
        price: 500,
        day: 5
    }
]


export default destinations;